// import { environment } from "../../../environments/environment"

// TODO: refactor to return RegExp directly; RegExp(AppConstants.DATA_URL_REGEX).test(src.substring(0,100))
export class AppConstants {

  // Code version
  // public static get CODE_VERSION(): string { return environment.version }

  // Regex string - leave out first and last '\'s
  // note: keep UTD with constants.rb (tho different syntax)
  // public EMAIL_REGEX = ".+\@.+\..+"
  public static get EMAIL_REGEX(): string { return ".+\@.+\..+" }
  public static get NUMBER_REGEX(): string { return "[+-]?([0-9]*[.])?[0-9]+" }
  // public static URL_REGEX = RegExp('[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?')
  //                                                     [-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?
  public static get URL_REGEX(): RegExp { return new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&/=]*)?/) }
  // public static get URL_REGEX(): string { return "[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?' }

  public static get DATA_URL_REGEX(): string { return "^data:.*" }
  // note: keep UTD with staticRootPages()
  public static get NAMED_ROUTES_REGEX(): string { return  "(auth|contact|dashboard|edit|home|new|policy|search)" }
  public static get PREFIX_ID_REGEX(): string { return "(e|c|l|p|u)[\\w]+" }
  public static get ITEM_TITLE_REGEX(): string { return "([\\w]?" }
  public static get PAGE_KEY_REGEX(): string { return '(' + this.NAMED_ROUTES_REGEX + "|" + this.PREFIX_ID_REGEX + ')' }
  public static get PRIMARY_ROUTE_MATCHER_REGEX(): string { return '^' + this.PAGE_KEY_REGEX + '\/?$' }

  // public static get URL_REGEX(): string { return "^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3})$" }

  // JWT expiration time in seconds: 30 days (86400 ms per min)
  // public static JWT_TIME = 60 * 60 * 24 * 30 

  // Google ReCaptcha Key
  public static get RECAPTCHA_SITE_KEY(): string { return '6LejwLEpAAAAAJrze00FXlwJWzu-Q4fCC-a6_zl0'} // '6LehB3IpAAAAAHFsmaY9jH3VjQPq27YT_xELojLm' }

  // Misc constants
  public static ENTRY_TITLE_MAX_LENGTH = 80
  public static ENTRY_DESCRIPTION_MAX_LENGTH = 140
  public static ITEM_COLLECTION_TITLE_MAX_LENGTH = 80
  public static ITEM_COLLECTION_DESCRIPTION_MAX_LENGTH = 140


  // PAGINATION / INFINITE-LIST

  // ITEMS_PER_PAGE_DEFAULT - keep UTD with BOTH:
  //    - kaminari_config.rb 'config.default_per_page'
  //    - Constants::Pagination::default_items_per_page
  // and check less than max:
  //    - kaminari_config.rb 'config.max_per_page'
  //    - SsHelpers::ss_per_from_param(max)

  public static ITEMS_PER_PAGE_DEFAULT: number = 100
  public static ITEMS_PER_PAGE_GROUP_DEFAULT: number = 5

  //
  // LIGHTBOX
  //

  public static get CONTROL_ICON_STYLES_LIGHTBOX(): any {
    return  {
      "back": {
        "icon_class": "fas fa-arrow-left",
        "icon_style": "margin-top-3" },
      "bars": {
        "icon_class": "fas fa-bars",
        "icon_style": "margin-top-3" },
      "crop": {
        "icon_class": "fas fa-crop-alt",
        "icon_style": "margin-top-3" },
      "close": {
        "icon_class": "far fa-times",
        "icon_style": "margin-top-3" },
      "edit": {
        "icon_class": "fas fa-pencil",
        "icon_style": "margin-top-3" },
      "info": {
        "icon_class": "fas fa-info-circle",
        "icon_style": "margin-top-3" },
      "list-alt": {
        "icon_class": "fas fa-th-list",
        "icon_style": "margin-top-3" },
      "search": {
        "icon_class": "fas fa-search",
        "icon_style": "margin-top-3" },
      "share": {
        "icon_class": "fas fa-share",
        "icon_style": "margin-top-3" },
      "trash": {
        "icon_class": "fas fa-trash-alt",
        "icon_style": "margin-top-3" }
    }
  }

  public static get LIGHTBOX_CONTROLS_IMAGE_1(): any[] {
    return [
      { name: 'info',
        text: 'Info',
        icon: 'info' },
      { name: 'close',
        text: 'Close',
        icon: 'close' },
      // { name: 'share',
      //   text: 'Share',
      //   icon: 'share' },
      // { name: 'crop',
      //   text: 'Crop',
      //   icon: 'crop' },
      // { name: 'trash',
      //   text: 'Trash',
      //   icon: 'trash',
      //   unless: true },
    ]
  }

  public static get LIGHTBOX_CONTROLS_IMAGE_2(): any[] {
    return [
      { name: 'edit',
        text: 'Edit',
        icon: 'edit',
        unless: true },
      { name: 'close',
        text: 'Close',
        icon: 'close' },
      // { name: 'trash',
      //   text: 'Trash',
      //   icon: 'trash',
      //   unless: true }
    ]
  }

  //
  // QUILL
  //

  public static get QUILL_EDITOR_CONTROLS_MAIN(): any[] {
    return  [
      { index: 1,
        name: "text-format",
        text: "Format Text",
        icon: "text-format" },
      { index: 2,
        name: "link",
        text: "Link",
        icon: "link" },
      { index: 3,
        name: "image",
        text: "Image",
        icon: "image" },
    ]
  }

  public static get QUILL_EDITOR_CONTROLS_MAIN_POLICY(): any[] {
    return  [
      { index: 1,
        name: "text-format",
        text: "Format Text",
        icon: "text-format" },
      { index: 2,
        name: "link",
        text: "Link",
        icon: "link" },
    ]
  }

  public static get QUILL_EDITOR_CONTROLS_TEXT(): any[] {
    return  [
      { index: 1,
        name: "bold",
        text: "Bold",
        icon: "bold" },
      { index: 2,
        name: "italic",
        text: "Italic",
        icon: "italic" },
      { index: 3,
        name: "list",
        text: "List",
        icon: "list-ol",
        multi: true },
      { index: 3,
        name: "list-ol",
        text: "Numbered List",
        icon: "list-ol" },
      { index: 3,
        name: "list-ul",
        text: "Bulleted List",
        icon: "list-ul" },
      { index: 4,
        name: "header",
        text: "Heading",
        icon: "header",
        multi: true },
      { index: 4,
        name: "h1",
        text: "Heading 1",
        icon: "header-h1" },
      { index: 4,
        name: "h2",
        text: "Heading 2",
        icon: "header-h2" },
      { index: 4,
        name: "h3",
        text: "Heading 3",
        icon: "header-h3" },
      { index: 5,
        name: "quote",
        text: "Blockquote",
        icon: "quote" },
      // { index: 6,
      //   name: "code",
      //   text: "Code",
      //   icon: "code-solid" },
      { index: 6,
        name: "code-inline",
        text: "Inline Code",
        icon: "code-light" },
      // { index: 6,
      //   name: "code-block",
      //   text: "Code Block",
      //   icon: "code-solid" },
      // { name: "clear-text-format",
      //   text: "Clear Formatting",
      //   icon: "clear-text-format" },
    ]
  }

  // COLLECTIONS, MAPS
  public static get LIST_VIEW_CONTROL(): any {
    return  { name: 'list',
              text: 'Close',
              icon: 'close' }
  }

  public static get LIGHTBOX_CONTROLS(): any[] {
    return  [
      // { name: 'close',
      //   text: 'Close',
      //   icon: 'close' }
      // { name: 'info',
      //   text: 'More Details',
      //   icon: 'info' }
    ]
  }

  // public static get ITEM_COLLECTION_CONTROLS(): any[] {
  //   return  [
  //     { name: 'info',
  //       text: 'More Details',
  //       icon: 'info' },
  //     // { name: 'filter',
  //     //   text: 'Filter',
  //     //   icon: 'filter' },
  //   ]
  // }

  public static get EXPLORATION_CONTROLS(): any[] {
    return [
      // { index: 1,
      //   name: "info",
      //   text: "More Details",
      //   icon: "info" },
      // { index: 2,
      //   name: "filter",
      //   text: "Filter",
      //   icon: "filter" },
    ]
  }

  // public static get PROFILE_ASSOCIATIONS_CONTROLS(): any[] {
  //   return []
  // }

  // public static get PROFILE_ENTRIES_CONTROLS(): any[] {
  //   return []
  // }

  // public static get PROFILE_COLLECTIONS_CONTROLS(): any[] {
  //   return []
  // }


  // MEDIA

  public static get MIME_TYPES_DICT(): any {
    return {
      '3dm': 'image',
      'ai': 'image',
      'bmp': 'image',
      'cdp': 'image',
      'cdr': 'image',
      'cr2': 'image',
      'dwg': 'image',
      'heic': 'image',
      'heif': 'image',
      'indd': 'image',
      'jpg': 'image',
      'jpeg': 'image',
      'nef': 'image',
      'pin': 'image',
      'psd': 'image',
      'png': 'image',
      'skp': 'image',
      'stp': 'image',
      'tif': 'image',
      'tiff': 'image',
      'wav': 'audio',
      'wma': 'audio',
      'mod': 'audio',
      'm4a': 'audio',
      'compress': 'compress',
      'rar': 'compress',
      '7z': 'compress',
      'lz': 'compress',
      'z01': 'compress',
      'pdf': 'pdf',
      'xls': 'xls',
      'xlsx': 'xls',
      'ods': 'xls',
      'mp4': 'video',
      'avi': 'video',
      'wmv': 'video',
      'mpg': 'video',
      'mts': 'video',
      'flv': 'video',
      '3gp': 'video',
      'vob': 'video',
      'm4v': 'video',
      'mpeg': 'video',
      'm2ts': 'video',
      'mov': 'video',
      'doc': 'doc',
      'docx': 'doc',
      'eps': 'doc',
      'txt': 'doc',
      'odt': 'doc',
      'rtf': 'doc',
      'ppt': 'ppt',
      'pptx': 'ppt',
      'pps': 'ppt',
      'ppsx': 'ppt',
      'odp': 'ppt'
    }
  }

  // COUNTRIES

  public static get COUNTRIES(): any[] {
    return [
      { "name": "Afghanistan", "code": "AF" },
      { "name": "Åland Islands", "code": "AX" },
      { "name": "Albania", "code": "AL" },
      { "name": "Algeria", "code": "DZ" },
      { "name": "American Samoa", "code": "AS" },
      { "name": "Andorra", "code": "AD" },
      { "name": "Angola", "code": "AO" },
      { "name": "Anguilla", "code": "AI" },
      { "name": "Antarctica", "code": "AQ" },
      { "name": "Antigua and Barbuda", "code": "AG" },
      { "name": "Argentina", "code": "AR" },
      { "name": "Armenia", "code": "AM" },
      { "name": "Aruba", "code": "AW" },
      { "name": "Australia", "code": "AU" },
      { "name": "Austria", "code": "AT" },
      { "name": "Azerbaijan", "code": "AZ" },
      { "name": "Bahamas", "code": "BS" },
      { "name": "Bahrain", "code": "BH" },
      { "name": "Bangladesh", "code": "BD" },
      { "name": "Barbados", "code": "BB" },
      { "name": "Belarus", "code": "BY" },
      { "name": "Belgium", "code": "BE" },
      { "name": "Belize", "code": "BZ" },
      { "name": "Benin", "code": "BJ" },
      { "name": "Bermuda", "code": "BM" },
      { "name": "Bhutan", "code": "BT" },
      { "name": "Bolivia", "code": "BO" },
      { "name": "Bosnia and Herzegovina", "code": "BA" },
      { "name": "Botswana", "code": "BW" },
      { "name": "Bouvet Island", "code": "BV" },
      { "name": "Brazil", "code": "BR" },
      { "name": "British Indian Ocean Territory", "code": "IO" },
      { "name": "Brunei Darussalam", "code": "BN" },
      { "name": "Bulgaria", "code": "BG" },
      { "name": "Burkina Faso", "code": "BF" },
      { "name": "Burundi", "code": "BI" },
      { "name": "Cambodia", "code": "KH" },
      { "name": "Cameroon", "code": "CM" },
      { "name": "Canada", "code": "CA" },
      { "name": "Cape Verde", "code": "CV" },
      { "name": "Cayman Islands", "code": "KY" },
      { "name": "Central African Republic", "code": "CF" },
      { "name": "Chad", "code": "TD" },
      { "name": "Chile", "code": "CL" },
      { "name": "China", "code": "CN" },
      { "name": "Christmas Island", "code": "CX" },
      { "name": "Cocos (Keeling) Islands", "code": "CC" },
      { "name": "Colombia", "code": "CO" },
      { "name": "Comoros", "code": "KM" },
      { "name": "Congo", "code": "CG" },
      { "name": "Congo, The Democratic Republic of the", "code": "CD" },
      { "name": "Cook Islands", "code": "CK" },
      { "name": "Costa Rica", "code": "CR" },
      { "name": "Cote D'Ivoire", "code": "CI" },
      { "name": "Croatia", "code": "HR" },
      { "name": "Cuba", "code": "CU" },
      { "name": "Cyprus", "code": "CY" },
      { "name": "Czech Republic", "code": "CZ" },
      { "name": "Denmark", "code": "DK" },
      { "name": "Djibouti", "code": "DJ" },
      { "name": "Dominica", "code": "DM" },
      { "name": "Dominican Republic", "code": "DO" },
      { "name": "Ecuador", "code": "EC" },
      { "name": "Egypt", "code": "EG" },
      { "name": "El Salvador", "code": "SV" },
      { "name": "Equatorial Guinea", "code": "GQ" },
      { "name": "Eritrea", "code": "ER" },
      { "name": "Estonia", "code": "EE" },
      { "name": "Ethiopia", "code": "ET" },
      { "name": "Falkland Islands (Malvinas)", "code": "FK" },
      { "name": "Faroe Islands", "code": "FO" },
      { "name": "Fiji", "code": "FJ" },
      { "name": "Finland", "code": "FI" },
      { "name": "France", "code": "FR" },
      { "name": "French Guiana", "code": "GF" },
      { "name": "French Polynesia", "code": "PF" },
      { "name": "French Southern Territories", "code": "TF" },
      { "name": "Gabon", "code": "GA" },
      { "name": "Gambia", "code": "GM" },
      { "name": "Georgia", "code": "GE" },
      { "name": "Germany", "code": "DE" },
      { "name": "Ghana", "code": "GH" },
      { "name": "Gibraltar", "code": "GI" },
      { "name": "Greece", "code": "GR" },
      { "name": "Greenland", "code": "GL" },
      { "name": "Grenada", "code": "GD" },
      { "name": "Guadeloupe", "code": "GP" },
      { "name": "Guam", "code": "GU" },
      { "name": "Guatemala", "code": "GT" },
      { "name": "Guernsey", "code": "GG" },
      { "name": "Guinea", "code": "GN" },
      { "name": "Guinea-Bissau", "code": "GW" },
      { "name": "Guyana", "code": "GY" },
      { "name": "Haiti", "code": "HT" },
      { "name": "Heard Island and Mcdonald Islands", "code": "HM" },
      { "name": "Holy See (Vatican City State)", "code": "VA" },
      { "name": "Honduras", "code": "HN" },
      { "name": "Hong Kong", "code": "HK" },
      { "name": "Hungary", "code": "HU" },
      { "name": "Iceland", "code": "IS" },
      { "name": "India", "code": "IN" },
      { "name": "Indonesia", "code": "ID" },
      { "name": "Iran, Islamic Republic Of", "code": "IR" },
      { "name": "Iraq", "code": "IQ" },
      { "name": "Ireland", "code": "IE" },
      { "name": "Isle of Man", "code": "IM" },
      { "name": "Israel", "code": "IL" },
      { "name": "Italy", "code": "IT" },
      { "name": "Jamaica", "code": "JM" },
      { "name": "Japan", "code": "JP" },
      { "name": "Jersey", "code": "JE" },
      { "name": "Jordan", "code": "JO" },
      { "name": "Kazakhstan", "code": "KZ" },
      { "name": "Kenya", "code": "KE" },
      { "name": "Kiribati", "code": "KI" },
      { "name": "Democratic People's Republic of Korea", "code": "KP" },
      { "name": "Korea, Republic of", "code": "KR" },
      { "name": "Kosovo", "code": "XK" },
      { "name": "Kuwait", "code": "KW" },
      { "name": "Kyrgyzstan", "code": "KG" },
      { "name": "Lao People's Democratic Republic", "code": "LA" },
      { "name": "Latvia", "code": "LV" },
      { "name": "Lebanon", "code": "LB" },
      { "name": "Lesotho", "code": "LS" },
      { "name": "Liberia", "code": "LR" },
      { "name": "Libyan Arab Jamahiriya", "code": "LY" },
      { "name": "Liechtenstein", "code": "LI" },
      { "name": "Lithuania", "code": "LT" },
      { "name": "Luxembourg", "code": "LU" },
      { "name": "Macao", "code": "MO" },
      { "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK" },
      { "name": "Madagascar", "code": "MG" },
      { "name": "Malawi", "code": "MW" },
      { "name": "Malaysia", "code": "MY" },
      { "name": "Maldives", "code": "MV" },
      { "name": "Mali", "code": "ML" },
      { "name": "Malta", "code": "MT" },
      { "name": "Marshall Islands", "code": "MH" },
      { "name": "Martinique", "code": "MQ" },
      { "name": "Mauritania", "code": "MR" },
      { "name": "Mauritius", "code": "MU" },
      { "name": "Mayotte", "code": "YT" },
      { "name": "Mexico", "code": "MX" },
      { "name": "Micronesia, Federated States of", "code": "FM" },
      { "name": "Moldova, Republic of", "code": "MD" },
      { "name": "Monaco", "code": "MC" },
      { "name": "Mongolia", "code": "MN" },
      { "name": "Montenegro", "code": "ME" },
      { "name": "Montserrat", "code": "MS" },
      { "name": "Morocco", "code": "MA" },
      { "name": "Mozambique", "code": "MZ" },
      { "name": "Myanmar", "code": "MM" },
      { "name": "Namibia", "code": "NA" },
      { "name": "Nauru", "code": "NR" },
      { "name": "Nepal", "code": "NP" },
      { "name": "Netherlands", "code": "NL" },
      { "name": "Netherlands Antilles", "code": "AN" },
      { "name": "New Caledonia", "code": "NC" },
      { "name": "New Zealand", "code": "NZ" },
      { "name": "Nicaragua", "code": "NI" },
      { "name": "Niger", "code": "NE" },
      { "name": "Nigeria", "code": "NG" },
      { "name": "Niue", "code": "NU" },
      { "name": "Norfolk Island", "code": "NF" },
      { "name": "Northern Mariana Islands", "code": "MP" },
      { "name": "Norway", "code": "NO" },
      { "name": "Oman", "code": "OM" },
      { "name": "Pakistan", "code": "PK" },
      { "name": "Palau", "code": "PW" },
      { "name": "Palestinian Territory, Occupied", "code": "PS" },
      { "name": "Panama", "code": "PA" },
      { "name": "Papua New Guinea", "code": "PG" },
      { "name": "Paraguay", "code": "PY" },
      { "name": "Peru", "code": "PE" },
      { "name": "Philippines", "code": "PH" },
      { "name": "Pitcairn", "code": "PN" },
      { "name": "Poland", "code": "PL" },
      { "name": "Portugal", "code": "PT" },
      { "name": "Puerto Rico", "code": "PR" },
      { "name": "Qatar", "code": "QA" },
      { "name": "Reunion", "code": "RE" },
      { "name": "Romania", "code": "RO" },
      { "name": "Russian Federation", "code": "RU" },
      { "name": "Rwanda", "code": "RW" },
      { "name": "Saint Helena", "code": "SH" },
      { "name": "Saint Kitts and Nevis", "code": "KN" },
      { "name": "Saint Lucia", "code": "LC" },
      { "name": "Saint Pierre and Miquelon", "code": "PM" },
      { "name": "Saint Vincent and the Grenadines", "code": "VC" },
      { "name": "Samoa", "code": "WS" },
      { "name": "San Marino", "code": "SM" },
      { "name": "Sao Tome and Principe", "code": "ST" },
      { "name": "Saudi Arabia", "code": "SA" },
      { "name": "Senegal", "code": "SN" },
      { "name": "Serbia", "code": "RS" },
      { "name": "Seychelles", "code": "SC" },
      { "name": "Sierra Leone", "code": "SL" },
      { "name": "Singapore", "code": "SG" },
      { "name": "Slovakia", "code": "SK" },
      { "name": "Slovenia", "code": "SI" },
      { "name": "Solomon Islands", "code": "SB" },
      { "name": "Somalia", "code": "SO" },
      { "name": "South Africa", "code": "ZA" },
      { "name": "South Georgia and the South Sandwich Islands", "code": "GS" },
      { "name": "Spain", "code": "ES" },
      { "name": "Sri Lanka", "code": "LK" },
      { "name": "Sudan", "code": "SD" },
      { "name": "Suriname", "code": "SR" },
      { "name": "Svalbard and Jan Mayen", "code": "SJ" },
      { "name": "Swaziland", "code": "SZ" },
      { "name": "Sweden", "code": "SE" },
      { "name": "Switzerland", "code": "CH" },
      { "name": "Syrian Arab Republic", "code": "SY" },
      { "name": "Taiwan", "code": "TW" },
      { "name": "Tajikistan", "code": "TJ" },
      { "name": "Tanzania, United Republic of", "code": "TZ" },
      { "name": "Thailand", "code": "TH" },
      { "name": "Timor-Leste", "code": "TL" },
      { "name": "Togo", "code": "TG" },
      { "name": "Tokelau", "code": "TK" },
      { "name": "Tonga", "code": "TO" },
      { "name": "Trinidad and Tobago", "code": "TT" },
      { "name": "Tunisia", "code": "TN" },
      { "name": "Turkey", "code": "TR" },
      { "name": "Turkmenistan", "code": "TM" },
      { "name": "Turks and Caicos Islands", "code": "TC" },
      { "name": "Tuvalu", "code": "TV" },
      { "name": "Uganda", "code": "UG" },
      { "name": "Ukraine", "code": "UA" },
      { "name": "United Arab Emirates", "code": "AE" },
      { "name": "United Kingdom", "code": "GB" },
      { "name": "United States", "code": "US" },
      { "name": "United States Minor Outlying Islands", "code": "UM" },
      { "name": "Uruguay", "code": "UY" },
      { "name": "Uzbekistan", "code": "UZ" },
      { "name": "Vanuatu", "code": "VU" },
      { "name": "Venezuela", "code": "VE" },
      { "name": "Viet Nam", "code": "VN" },
      { "name": "Virgin Islands, British", "code": "VG" },
      { "name": "Virgin Islands, U.S.", "code": "VI" },
      { "name": "Wallis and Futuna", "code": "WF" },
      { "name": "Western Sahara", "code": "EH" },
      { "name": "Yemen", "code": "YE" },
      { "name": "Zambia", "code": "ZM" },
      { "name": "Zimbabwe", "code": "ZW" }
    ]
  }

  // note: from https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/5912746#5912746
  // public static get DIACRITICS_REMOVAL_MAP(): any[] {
  //   return [
  //     {'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
  //     {'base':'AA','letters':/[\uA732]/g},
  //     {'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
  //     {'base':'AO','letters':/[\uA734]/g},
  //     {'base':'AU','letters':/[\uA736]/g},
  //     {'base':'AV','letters':/[\uA738\uA73A]/g},
  //     {'base':'AY','letters':/[\uA73C]/g},
  //     {'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
  //     {'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
  //     {'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
  //     {'base':'DZ','letters':/[\u01F1\u01C4]/g},
  //     {'base':'Dz','letters':/[\u01F2\u01C5]/g},
  //     {'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
  //     {'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
  //     {'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
  //     {'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
  //     {'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
  //     {'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
  //     {'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
  //     {'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
  //     {'base':'LJ','letters':/[\u01C7]/g},
  //     {'base':'Lj','letters':/[\u01C8]/g},
  //     {'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
  //     {'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
  //     {'base':'NJ','letters':/[\u01CA]/g},
  //     {'base':'Nj','letters':/[\u01CB]/g},
  //     {'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
  //     {'base':'OI','letters':/[\u01A2]/g},
  //     {'base':'OO','letters':/[\uA74E]/g},
  //     {'base':'OU','letters':/[\u0222]/g},
  //     {'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
  //     {'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
  //     {'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
  //     {'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
  //     {'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
  //     {'base':'TZ','letters':/[\uA728]/g},
  //     {'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
  //     {'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
  //     {'base':'VY','letters':/[\uA760]/g},
  //     {'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
  //     {'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
  //     {'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
  //     {'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
  //     {'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
  //     {'base':'aa','letters':/[\uA733]/g},
  //     {'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
  //     {'base':'ao','letters':/[\uA735]/g},
  //     {'base':'au','letters':/[\uA737]/g},
  //     {'base':'av','letters':/[\uA739\uA73B]/g},
  //     {'base':'ay','letters':/[\uA73D]/g},
  //     {'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
  //     {'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
  //     {'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
  //     {'base':'dz','letters':/[\u01F3\u01C6]/g},
  //     {'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
  //     {'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
  //     {'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
  //     {'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
  //     {'base':'hv','letters':/[\u0195]/g},
  //     {'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
  //     {'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
  //     {'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
  //     {'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
  //     {'base':'lj','letters':/[\u01C9]/g},
  //     {'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
  //     {'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
  //     {'base':'nj','letters':/[\u01CC]/g},
  //     {'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
  //     {'base':'oi','letters':/[\u01A3]/g},
  //     {'base':'ou','letters':/[\u0223]/g},
  //     {'base':'oo','letters':/[\uA74F]/g},
  //     {'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
  //     {'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
  //     {'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
  //     {'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
  //     {'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
  //     {'base':'tz','letters':/[\uA729]/g},
  //     {'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
  //     {'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
  //     {'base':'vy','letters':/[\uA761]/g},
  //     {'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
  //     {'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
  //     {'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
  //     {'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
  //     ]
  // }

}
